import React, { useState, useEffect, useRef } from "react";
import MUIDataTable from "mui-datatables";
import {
  Grid,
  Button,
  List,
  Box,
  SwipeableDrawer,
  Switch,
  TextField,
  MenuItem,
  Select,
  FormControl,
  FormControlLabel,
  FormGroup,
  Checkbox,
  InputLabel,
  Typography,
  TablePagination,
  Backdrop,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  Tooltip,
  withStyles,
} from "@material-ui/core";
import PageTitle from "../../components/PageTitle";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardHeader from "@material-ui/core/CardMedia";
import CardActions from "@material-ui/core/CardActions";
import { toast } from "react-toastify";
import moment from "moment";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import CloseIcon from "@material-ui/icons/Close";
import { IoMdDownload } from "react-icons/io";
import { AiOutlineDelete } from "react-icons/ai";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import Notification from "../../components/Notification";
import { Autocomplete } from "@material-ui/lab";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import useStyles from "../../themes/style.js";
import AddUser from "../../components/Admin/AddUser";
import { jwtDecode } from "jwt-decode";
import { getFileExtension } from "../../utils/getextension.js";
import CustomPdfView from "../../components/pdfViewer/CustomPdfView.js";
import UserActions from "./UserActions.js";
import { HiQuestionMarkCircle } from "react-icons/hi2";

const positions = [toast.POSITION.TOP_RIGHT];

const InformationTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: "#c8d8f8",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 250,
    fontFamily: "'Inter', sansSerif",
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #7da5f6",
  },
  arrow: {
    color: "#7da5f6",
  },
}))(Tooltip);

export default function Tables() {
  const classes = useStyles();
  const [loader, setLoader] = useState(false);
  const mobileQuery = useMediaQuery("(max-width:600px)");

  const token = localStorage.getItem("token");
  const decode = jwtDecode(token);
  const companyType = decode?.companyType;
  const [userData, setUserData] = useState([]);
  const [userEdit, setUserEdit] = useState({
    id: "",
    email: "",
    firstName: "",
    lastName: "",
    mobile: "",
    companyName: "",
    isActive: "",
    employeeId: "",
    companyAddress: "",
    headOfficeLocation: "",
    branchOfficeLocation: "",
    capabilities: "",
    recruiterCapacity: "",
    totalExp: "",
    currentLocation: "",
    willingToWork: "",
    hoursToWork: "",

    minimumCommercialFee: "",
    minimumMarkup: "",
    sourceProfileFrom: "",
    contractStaffing: "",
    aboutATS: "",
    GSTNumber: "",

    currentAddress: "",
    permanentAddress: "",
    joinningDate: "",
    fatherName: "",
    motherName: "",
    fatherOccupation: "",
    motherOccupation: "",
    fatherMobile: "",
    motherMobile: "",
    spouseName: "",
    dob: "",
    emergencyMobile: "",
    uanNumber: "",
    aadhaarNumber: "",
    panNumber: "",
    empId: "",
    bankName: "",
    bankAccountNumber: "",
    bankIfscCode: "",
    companyBranchName: "",
    bloodGroup: "",
    totalExperience: "",
    basicSalary: "",
    specialAllowance: "",
    shiftAllowance: "",
    isContract: "",
    contractPeriod: "",
    contractClientName: "",
  });
  const [page, setPage] = useState(0);
  const [currerntPage, setCurrerntPage] = useState(1);
  const [count, setCount] = useState(0);

  const [dataList, setDataList] = useState("ADD");

  var [notificationsPosition] = useState(2);
  var [errorToastId, setErrorToastId] = useState(null);
  const [deleteOpen, setDeleteOpen] = React.useState(false);
  const [ndaFileOpen, setNdaFileOpen] = useState(false);
  const [ndaFile, setNdaFile] = useState(null);
  const [ndaFileId, setNdaFileId] = useState("");
  const ndaFileUrl = ndaFile;
  const fileExtension = ndaFileUrl ? getFileExtension(ndaFileUrl) : null;


  //Action Button Popper
  const [anchorEl, setAnchorEl] = useState(null);
  const [activeIndex, setActiveIndex] = useState(null);
  const handleMenuClick = (index, event) => {
    if (activeIndex === index) {
      setAnchorEl(null);
      setActiveIndex(null);
    } else {
      setAnchorEl(event.currentTarget);
      setActiveIndex(index);
    }
  };

  const handleSourceProfileCheck = (event) => {
    setVendorDetails({
      ...vendorDetails,
      [event.target.name]: event.target.checked,
    });
  };

  const handleVendorDetailsChange = (event) => {
    setVendorDetails({
      ...vendorDetails,
      [event.target.name]: event.target.value,
    });
  };

  const handleEditSourceProfileCheck = (event) => {
    setEditVendorDetails({
      ...editVendorDetails,
      [event.target.name]: event.target.checked,
    });
  };

  const handleEditVendorDetailsChange = (event) => {
    setEditVendorDetails({
      ...editVendorDetails,
      [event.target.name]: event.target.value,
    });
  };

  const handleNDAOpen = (item) => {
    const file = item?.nda;
    if (file) {
      setNdaFile(`${process.env.REACT_APP_AWS_BUCKET_URL}${file}`);
    } else {
      setNdaFile(null);
    }
    setNdaFileOpen(true);
    setNdaFileId(item.id);
  };

  const handleNDAClose = () => {
    setNdaFileOpen(false);
  };

  const handleDeleteOpen = () => {
    setDeleteOpen(true);
  };

  const handleDeleteClose = () => {
    setDeleteOpen(false);
  };

  const HeaderElements = () => <>Total : {count}</>;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setLoader(true);
    setCurrerntPage(newPage + 1);

    const form = filterRef.current;

    var data = JSON.stringify({
      page: newPage + 1,
      roleName: `${form["roleName"].value}`,
      fromDate: `${form["fromDate"].value}`,
      toDate: `${form["toDate"].value}`,
      recruiterId: recruiterId?.id,
    });

    axios({
      method: "post",
      url: `${process.env.REACT_APP_SERVER}admin/viewAllUsers`,
      data: data,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }).then(function (response) {
      if (response.data.status === true) {
        setUserData(response.data.data);
        setCount(response.data.count);
      }

      setLoader(false);
    });
  };

  const handleDeleteNDAFile = () => {
    setLoader(true);
    axios({
      method: "post",
      url: `${process.env.REACT_APP_SERVER}admin/removeNda`,
      data: {
        recruiterId: ndaFileId,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    })
      .then(function (response) {
        if (response.data.status === true) {
          handleNotificationCall("success", response.data.message);
          handleDeleteClose();
          handleNDAClose();
          fetchUserData();
        }

        setLoader(false);
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
      });
  };

  function sendNotification(componentProps, options) {
    return toast(
      <Notification
        {...componentProps}
        className={classes.notificationComponent}
      />,
      options,
    );
  }
  function handleNotificationCall(notificationType, message) {
    var componentProps;

    if (errorToastId && notificationType === "error") return;

    switch (notificationType) {
      case "info":
        componentProps = {
          type: "feedback",
          message: message,
          variant: "contained",
          color: "primary",
        };
        break;
      case "error":
        componentProps = {
          type: "message",
          message: message,
          variant: "contained",
          color: "secondary",
        };
        break;
      default:
        componentProps = {
          type: "shipped",
          message: message,
          variant: "contained",
          color: "success",
        };
    }

    var toastId = sendNotification(componentProps, {
      type: notificationType,
      position: positions[notificationsPosition],
      progressClassName: classes.progress,
      onClose: notificationType === "error" && (() => setErrorToastId(null)),
      className: classes.notification,
    });

    if (notificationType === "error") setErrorToastId(toastId);
  }

  const [roleName, setRoleName] = useState("");
  const [userRoleName, setUserRoleName] = useState("");
  const [vendorDetails, setVendorDetails] = useState({
    JobPortal: false,
    SocialMedia: false,
    Reference: false,
    OthersMention: false,
    OthersMentionValue: "",
    contractStaffing: "",
    minimumCommercialFee: "",
  });

  const [editVendorDetails, setEditVendorDetails] = useState({
    JobPortal: false,
    SocialMedia: false,
    Reference: false,
    OthersMention: false,
    OthersMentionValue: "",
    contractStaffing: "",
    minimumCommercialFee: "",
  });

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .required("Email is required")
      .email("Email must be a Valid Email Address"),
    firstName: Yup.string()
      .max(255)
      .required("First Name is required")
      .matches(/^[^!@#$%^&*+=<>:;|~]*$/, {
        message: "First Name be Alphanumeric",
      }),
    lastName: Yup.string()
      .max(255)
      .required("Last Name is required")
      .matches(/^[^!@#$%^&*+=<>:;|~]*$/, {
        message: "Last Name be Alphanumeric",
      }),
    mobile: Yup.string()
      .required("Mobile is required")
      .min(10, "Must be exactly 10 digits")
      .max(10, "Must be exactly 10 digits"),
    roleName: Yup.string().required("User Category is required"),
    password: Yup.string()
      .required("Password is required")
      .min(8, "Password must be at least 8 characters"),
    employeeId: Yup.string(),
    companyName: Yup.string().when([], {
      is: () => userRoleName === "SUBVENDOR" || userRoleName === "SUBCONTRACT",
      then: Yup.string().required("Company Name is required"),
      otherwise: Yup.string(),
    }),
    companyAddress: Yup.string().when([], {
      is: () => userRoleName === "SUBVENDOR" || userRoleName === "SUBCONTRACT",
      then: Yup.string().required("Company Address is required"),
      otherwise: Yup.string(),
    }),
    headOfficeLocation: Yup.string().when([], {
      is: () => userRoleName === "SUBVENDOR" || userRoleName === "SUBCONTRACT",
      then: Yup.string().required("Head Office Location is required"),
      otherwise: Yup.string(),
    }),
    branchOfficeLocation: Yup.string().when([], {
      is: () => userRoleName === "SUBVENDOR" || userRoleName === "SUBCONTRACT",
      then: Yup.string().required("Branch office Location is required"),
      otherwise: Yup.string(),
    }),
    capabilities: Yup.string().when([], {
      is: () => userRoleName === "SUBVENDOR" || userRoleName === "SUBCONTRACT",
      then: Yup.string().required("Hiring Support Capabilities is required"),
      otherwise: Yup.string(),
    }),
    recruiterCapacity: Yup.string().when([], {
      is: () => userRoleName === "SUBVENDOR" || userRoleName === "SUBCONTRACT",
      then: Yup.string().required("Recruiter Capacity is required"),
      otherwise: Yup.string(),
    }),
    totalExp: Yup.string().when([], {
      is: () => userRoleName === "SUBVENDOR",
      then: Yup.string().required("Total Experiance is required"),
      otherwise: Yup.string(),
    }),
    currentLocation: Yup.string().when([], {
      is: () => userRoleName === "SUBVENDOR",
      then: Yup.string().required("Current Location is required"),
      otherwise: Yup.string(),
    }),
    willingToWork: Yup.string().when([], {
      is: () => userRoleName === "SUBVENDOR",
      then: Yup.string().required("This is required"),
      otherwise: Yup.string(),
    }),
    hoursToWork: Yup.string().when([], {
      is: () => userRoleName === "SUBVENDOR",
      then: Yup.string().required("This is required"),
      otherwise: Yup.string(),
    }),

    minimumCommercialFee: Yup.string().when([], {
      is: () => userRoleName === "SUBCONTRACT",
      then: Yup.string().required(
        "Your Minimum Commercial Fee per Candidate Placement is required",
      ),
      otherwise: Yup.string(),
    }),
    contractStaffing: Yup.string().when([], {
      is: () => userRoleName === "SUBCONTRACT",
      then: Yup.string().required("Contract Staffing is required"),
      otherwise: Yup.string(),
    }),
    minimumMarkup: Yup.string(),
    aboutATS: Yup.string().when([], {
      is: () => userRoleName === "SUBCONTRACT",
      then: Yup.string().required("ATS Details is required"),
      otherwise: Yup.string(),
    }),
    sourceProfileFrom: Yup.string().when([], {
      is: () =>
        userRoleName === "SUBCONTRACT" &&
        (vendorDetails.JobPortal === true ||
          vendorDetails.SocialMedia === true ||
          vendorDetails.Reference === true ||
          vendorDetails.OthersMention === true),
      then: Yup.string(),
      otherwise: Yup.string(),
    }),
    GSTNumber: Yup.string(),

    //employee schema
    currentAddress: Yup.string().when([], {
      is: () => userRoleName === "EMPLOYEE",
      then: Yup.string().required("Current Address is required"),
      otherwise: Yup.string(),
    }),
    permanentAddress: Yup.string().when([], {
      is: () => userRoleName === "EMPLOYEE",
      then: Yup.string().required("Permanent Address is required"),
      otherwise: Yup.string(),
    }),
    joinningDate: Yup.string().when([], {
      is: () => userRoleName === "EMPLOYEE",
      then: Yup.string().required("Permanent Address is required"),
      otherwise: Yup.string(),
    }),
    fatherName: Yup.string().when([], {
      is: () => userRoleName === "EMPLOYEE",
      then: Yup.string().required("Father Name is required"),
      otherwise: Yup.string(),
    }),
    motherName: Yup.string().when([], {
      is: () => userRoleName === "EMPLOYEE",
      then: Yup.string().required("Mother Name is required"),
      otherwise: Yup.string(),
    }),
    fatherOccupation: Yup.string(),
    motherOccupation: Yup.string(),
    fatherMobile: Yup.string(),
    motherMobile: Yup.string(),
    spouseName: Yup.string(),
    dob: Yup.string(),
    emergencyMobile: Yup.string().when([], {
      is: () => userRoleName === "EMPLOYEE",
      then: Yup.string()
        .required("Emergency Mobile is required")
        .min(10, "Must be exactly 10 digits")
        .max(10, "Must be exactly 10 digits"),
      otherwise: Yup.string(),
    }),
    uanNumber: "",
    aadhaarNumber: Yup.string().when([], {
      is: () => userRoleName === "EMPLOYEE",
      then: Yup.string().required("Aadhar Number is required"),
      otherwise: Yup.string(),
    }),
    panNumber: Yup.string().when([], {
      is: () => userRoleName === "EMPLOYEE",
      then: Yup.string().required("PAN Number is required"),
      otherwise: Yup.string(),
    }),
    empId: Yup.string(),
    bankName: Yup.string(),
    bankAccountNumber: Yup.string(),
    bankIfscCode: Yup.string(),
    companyBranchName: Yup.string(),
    bloodGroup: Yup.string(),
    totalExperience: Yup.string().when([], {
      is: () => userRoleName === "EMPLOYEE",
      then: Yup.string().required("Total Experience field is required"),
      otherwise: Yup.string(),
    }),
    basicSalary: Yup.string(),
    specialAllowance: Yup.string(),
    shiftAllowance: Yup.string(),
    isContract: Yup.boolean().when([], {
      is: () => userRoleName === "EMPLOYEE",
      then: Yup.boolean()
        .required("This field is required")
        .oneOf([true, false], "Invalid value for isContract"),
      otherwise: Yup.boolean().oneOf(
        [true, false],
        "Invalid value for isContract",
      ),
    }),
    contractPeriod: Yup.string(),
    contractClientName: Yup.string(),
  });

  const editSchema = Yup.object().shape({
    email: Yup.string()
      .required("Email is required")
      .email("Email must be a Valid Email Address"),
    firstName: Yup.string()
      .max(255)
      .required("First Name is required")
      .matches(/^[^!@#$%^&*+=<>:;|~]*$/, {
        message: "First Name be Alphanumeric",
      }),
    lastName: Yup.string()
      .max(255)
      .required("Last Name is required")
      .matches(/^[^!@#$%^&*+=<>:;|~]*$/, {
        message: "Last Name be Alphanumeric",
      }),
    mobile: Yup.string()
      .required("Mobile is required")
      .min(10, "Must be exactly 10 digits")
      .max(10, "Must be exactly 10 digits"),
    roleName: Yup.string().required("User Category is required"),
    employeeId: Yup.string(),
    companyName: Yup.string().when([], {
      is: () => userRoleName === "SUBVENDOR" || userRoleName === "SUBCONTRACT",
      then: Yup.string().required("Company Name is required"),
      otherwise: Yup.string(),
    }),
    companyAddress: Yup.string().when([], {
      is: () => userRoleName === "SUBVENDOR" || userRoleName === "SUBCONTRACT",
      then: Yup.string().required("Company Address is required"),
      otherwise: Yup.string(),
    }),
    headOfficeLocation: Yup.string().when([], {
      is: () => userRoleName === "SUBVENDOR" || userRoleName === "SUBCONTRACT",
      then: Yup.string().required("Head Office Location is required"),
      otherwise: Yup.string(),
    }),
    branchOfficeLocation: Yup.string().when([], {
      is: () => userRoleName === "SUBVENDOR" || userRoleName === "SUBCONTRACT",
      then: Yup.string().required("Branch office Location is required"),
      otherwise: Yup.string(),
    }),
    capabilities: Yup.string().when([], {
      is: () => userRoleName === "SUBVENDOR" || userRoleName === "SUBCONTRACT",
      then: Yup.string().required("Hiring Support Capabilities is required"),
      otherwise: Yup.string(),
    }),
    recruiterCapacity: Yup.string().when([], {
      is: () => userRoleName === "SUBVENDOR" || userRoleName === "SUBCONTRACT",
      then: Yup.string().required("Recruiter Capacity is required"),
      otherwise: Yup.string(),
    }),
    totalExp: Yup.string().when([], {
      is: () => userRoleName === "SUBVENDOR",
      then: Yup.string().required("Total Experiance is required"),
      otherwise: Yup.string(),
    }),
    currentLocation: Yup.string().when([], {
      is: () => userRoleName === "SUBVENDOR",
      then: Yup.string().required("Current Location is required"),
      otherwise: Yup.string(),
    }),
    willingToWork: Yup.string().when([], {
      is: () => userRoleName === "SUBVENDOR",
      then: Yup.string().required("This is required"),
      otherwise: Yup.string(),
    }),
    hoursToWork: Yup.string().when([], {
      is: () => userRoleName === "SUBVENDOR",
      then: Yup.string().required("This is required"),
      otherwise: Yup.string(),
    }),

    minimumCommercialFee: Yup.string().when([], {
      is: () => userRoleName === "SUBCONTRACT",
      then: Yup.string().required(
        "Your Minimum Commercial Fee per Candidate Placement is required",
      ),
      otherwise: Yup.string(),
    }),
    contractStaffing: Yup.string().when([], {
      is: () => userRoleName === "SUBCONTRACT",
      then: Yup.string().required("Contract Staffing is required"),
      otherwise: Yup.string(),
    }),
    minimumMarkup: Yup.string(),
    aboutATS: Yup.string().when([], {
      is: () => userRoleName === "SUBCONTRACT",
      then: Yup.string().required("ATS Details is required"),
      otherwise: Yup.string(),
    }),
    sourceProfileFrom: Yup.string().when([], {
      is: () =>
        userRoleName === "SUBCONTRACT" &&
        (editVendorDetails.JobPortal === true ||
          editVendorDetails.SocialMedia === true ||
          editVendorDetails.Reference === true ||
          editVendorDetails.OthersMention === true),
      then: Yup.string(),
      otherwise: Yup.string(),
    }),
    GSTNumber: Yup.string(),

    currentAddress: Yup.string().when([], {
      is: () => userRoleName === "EMPLOYEE",
      then: Yup.string().required("Current Address is required"),
      otherwise: Yup.string(),
    }),
    permanentAddress: Yup.string().when([], {
      is: () => userRoleName === "EMPLOYEE",
      then: Yup.string().required("Permanent Address is required"),
      otherwise: Yup.string(),
    }),
    joinningDate: Yup.string().when([], {
      is: () => userRoleName === "EMPLOYEE",
      then: Yup.string().required("Permanent Address is required"),
      otherwise: Yup.string(),
    }),
    fatherName: Yup.string().when([], {
      is: () => userRoleName === "EMPLOYEE",
      then: Yup.string().required("Father Name is required"),
      otherwise: Yup.string(),
    }),
    motherName: Yup.string().when([], {
      is: () => userRoleName === "EMPLOYEE",
      then: Yup.string().required("Mother Name is required"),
      otherwise: Yup.string(),
    }),
    fatherOccupation: Yup.string(),
    motherOccupation: Yup.string(),
    fatherMobile: Yup.string(),
    motherMobile: Yup.string(),
    spouseName: Yup.string(),
    dob: Yup.string(),
    emergencyMobile: Yup.string().when([], {
      is: () => userRoleName === "EMPLOYEE",
      then: Yup.string()
        .required("Emergency Mobile is required")
        .min(10, "Must be exactly 10 digits")
        .max(10, "Must be exactly 10 digits"),
      otherwise: Yup.string(),
    }),
    uanNumber: "",
    aadhaarNumber: Yup.string().when([], {
      is: () => userRoleName === "EMPLOYEE",
      then: Yup.string().required("Aadhar Number is required"),
      otherwise: Yup.string(),
    }),
    panNumber: Yup.string().when([], {
      is: () => userRoleName === "EMPLOYEE",
      then: Yup.string().required("PAN Number is required"),
      otherwise: Yup.string(),
    }),
    empId: Yup.string(),
    bankName: Yup.string(),
    bankAccountNumber: Yup.string(),
    bankIfscCode: Yup.string(),
    companyBranchName: Yup.string(),
    bloodGroup: Yup.string(),
    totalExperience: Yup.string().when([], {
      is: () => userRoleName === "EMPLOYEE",
      then: Yup.string().required("Total Experience field is required"),
      otherwise: Yup.string(),
    }),
    basicSalary: Yup.string(),
    specialAllowance: Yup.string(),
    shiftAllowance: Yup.string(),
    isContract: Yup.boolean().when([], {
      is: () => userRoleName === "EMPLOYEE",
      then: Yup.boolean()
        .required("This field is required")
        .oneOf([true, false], "Invalid value for isContract"),
      otherwise: Yup.boolean().oneOf(
        [true, false],
        "Invalid value for isContract",
      ),
    }),
    contractPeriod: Yup.string(),
    contractClientName: Yup.string(),
  });

  const {
    register: editUser,
    formState: { errors: editErrors, isSubmitting: editIsSubmitting },
    handleSubmit: editSubmit,
    reset: editreset,
  } = useForm({
    mode: "onBlur",
    resolver: yupResolver(editSchema),
  });

  const {
    register,
    control,
    reset,
    handleSubmit,
    setValue,
    watch,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      isContract: false,
    },
  });

  const isContract = watch("isContract");

  useEffect(() => {
    fetchUserData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchUserData = async () => {
    try {
      setLoader(true);
      axios({
        method: "post",
        url: `${process.env.REACT_APP_SERVER}admin/viewAllUsers`,
        data: {
          page: currerntPage,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }).then(function (response) {
        if (response.data.status === true) {
          setLoader(false);
          setUserData(response.data.data);
          setCount(response.data.count);
        }
      });
      getUserName();
      getAllUserList();
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const getUserName = async () => {
    axios({
      method: "post",
      url: `${process.env.REACT_APP_SERVER}admin/allRecruiterList`,
      data: {},
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    })
      .then(function (response) {
        if (response.data.status === true) {
          setLoader(false);
          setUserName(response.data.data);
        }
      })

      .catch(function (error) {
        console.log(error);
      });
  };

  const getAllUserList = async () => {
    try {
      setLoader(true);

      const response = await axios.get(
        `${process.env.REACT_APP_SERVER}auth/getAllUserList`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      setLoader(false);
      if (response.data.status) {
        const responseData = response.data.data;
        const userList = responseData.filter((item) => item.fullName !== null);
        setAllUserName(userList);
        console.log(response.data.data);
      } else {
        handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
    }
  };

  function handleStatus(id, value) {
    setLoader(true);
    axios({
      method: "post",
      url: `${process.env.REACT_APP_SERVER}admin/changeUserState`,
      data: {
        id: id,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    }).then(function (response) {
      if (response.data.status === true) {
        setLoader(false);
        const switchState = userData.map((item) => {
          if (item.user.id === id) {
            return { ...item, user: { ...item.user, isActive: value } };
          }
          return item;
        });
        setUserData(switchState);
        handleNotificationCall("success", response.data.data);
      }
    });
  }

  function handleAdd(values) {
    return new Promise((resolve) => {
      setLoader(true);

      let updatedSource = "";

      if (vendorDetails.JobPortal) {
        updatedSource += "Job Portal, ";
      }
      if (vendorDetails.SocialMedia) {
        updatedSource += "Social Media, ";
      }
      if (vendorDetails.Reference) {
        updatedSource += "Reference, ";
      }
      if (
        vendorDetails.OthersMention &&
        vendorDetails.OthersMentionValue !== ""
      ) {
        updatedSource += `${vendorDetails.OthersMentionValue}, `; // You can also use vendorDetails.OthersMentionValue
      }

      const profileSource = updatedSource.trimEnd().replace(/,\s*$/, "");
      console.log(profileSource);

      axios({
        method: "post",
        url: `${process.env.REACT_APP_SERVER}admin/addUser`,
        data: {
          firstName: values.firstName,
          lastName: values.lastName,
          email: values.email,
          password: values.password,
          mobile: values.mobile,
          roleName: values.roleName,
          employeeId: values.employeeId,
          companyName: values.companyName,
          companyAddress: values.companyAddress,
          headOfficeLocation: values.headOfficeLocation,
          branchOfficeLocation: values.branchOfficeLocation,
          capabilities: values.capabilities,
          recruiterCapacity: values.recruiterCapacity,
          totalExp: values.totalExp,
          currentLocation: values.currentLocation,
          willingToWork: values.willingToWork,
          hoursToWork: values.hoursToWork,

          //vendor data
          minimumCommercialFee: values.minimumCommercialFee,
          minimumMarkup: values.minimumMarkup,
          contractStaffing: values.contractStaffing,
          sourceProfileFrom: profileSource,
          aboutATS: values.aboutATS,
          GSTNumber: values.GSTNumber,

          //employee data
          ...values,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      })
        .then(function (response) {
          resolve();
          setLoader(false);

          if (response.data.status === true) {
            setState({ ...state, right: false });
            fetchUserData();
            handleNotificationCall("success", response.data.message);
          } else {
            handleNotificationCall("error", response.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
          setLoader(false);
        });
    });
  }

  function handleEdit(values) {
    return new Promise((resolve) => {
      setLoader(true);

      let updatedSource = "";

      if (editVendorDetails.JobPortal) {
        updatedSource += "Job Portal, ";
      }
      if (editVendorDetails.SocialMedia) {
        updatedSource += "Social Media, ";
      }
      if (editVendorDetails.Reference) {
        updatedSource += "Reference, ";
      }
      if (editVendorDetails.OthersMention) {
        updatedSource += `${editVendorDetails.OthersMentionValue}, `; // You can also use vendorDetails.OthersMentionValue
      }

      const editedProfileSource = updatedSource.trimEnd().replace(/,\s*$/, "");

      axios({
        method: "post",
        url: `${process.env.REACT_APP_SERVER}admin/editUser`,
        data: {
          id: userEdit.id,
          firstName: values.firstName,
          lastName: values.lastName,
          email: values.email,
          mobile: values.mobile,
          password: values.password,
          roleName: values.roleName,
          companyName: values.companyName,
          employeeId: values.employeeId,
          companyAddress: values.companyAddress,
          headOfficeLocation: values.headOfficeLocation,
          branchOfficeLocation: values.branchOfficeLocation,
          capabilities: values.capabilities,
          recruiterCapacity: values.recruiterCapacity,
          totalExp: values.totalExp,
          currentLocation: values.currentLocation,
          willingToWork: values.willingToWork,
          hoursToWork: values.hoursToWork,

          minimumCommercialFee: values.minimumCommercialFee,
          minimumMarkup: values.minimumMarkup,
          contractStaffing: values.contractStaffing,
          sourceProfileFrom: editedProfileSource,
          aboutATS: values.aboutATS,
          GSTNumber: values.GSTNumber,
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      })
        .then(function (response) {
          if (response.data.status === true) {
            handleNotificationCall("success", response.data.message);
            fetchUserData();
            setState({ ...state, right: false });
          } else {
            handleNotificationCall("error", response.data.message);
          }

          setLoader(false);
        })
        .catch(function (error) {
          setLoader(false);
          console.log(error);
        });
    });
  }

  const [state, setState] = useState({
    bottom: false,
    right: false,
  });
  const toggleDrawer = (anchor, open) => (event) => {
    setState({ ...state, [anchor]: open });
  };

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [userName, setUserName] = useState([]);
  const [allUserName, setAllUserName] = useState([]);
  const [recruiterId, setRecruiterId] = useState(null);

  const filterRef = useRef(null);

  const handleFromDateChange = (event) => {
    setFromDate(filterRef.current.fromDate.value);
  };

  const handleToDateChange = (event) => {
    setToDate(filterRef.current.toDate.value);
  };

  const resetForm = (e) => {
    filterRef.current.reset();
    setRoleName("");
    setRecruiterId(null);
    fetchUserData();
  };

  function getFilterData() {
    setLoader(true);
    setCurrerntPage(1);
    setPage(0);
    const form = filterRef.current;

    var data = JSON.stringify({
      page: 1,
      roleName: `${form["roleName"].value}`,
      fromDate: `${form["fromDate"].value}`,
      toDate: `${form["toDate"].value}`,
      recruiterId: recruiterId?.id,
    });

    axios({
      method: "post",
      url: `${process.env.REACT_APP_SERVER}admin/viewAllUsers`,
      data: data,
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    })
      .then(function (response) {
        if (response.data.status === true) {
          setLoader(false);
          setUserData(response.data.data);
          setCount(response.data.count);
        }
      })

      .catch(function (error) {
        console.log(error);
      });
  }

  const list = (anchor) =>
    dataList === "EDIT" ? (
      <>
        <Box sx={{ width: "100%" }} role="presentation">
          <List>
            <Card className={classes.root}>
              <CardHeader>
                <Grid
                  container
                  direction="row"
                  spacing={1}
                  className={classes.drawerHeader}
                >
                  <Grid item xs={10} md={6}>
                    <Typography variant="subtitle1">Edit User</Typography>
                  </Grid>

                  <Grid item xs={2} lg={6} className={classes.drawerClose}>
                    <CloseIcon
                      className={classes.closeBtn}
                      size="14px"
                      onClick={toggleDrawer(anchor, false)}
                    />
                  </Grid>
                </Grid>
              </CardHeader>

              <form onSubmit={editSubmit(handleEdit)}>
                <CardContent className={classes.scrollCard}>
                  <Grid container direction="row" spacing={2}>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <FormControl className={classes.margin}>
                        <InputLabel shrink htmlFor="roleName">
                          Select User Category
                        </InputLabel>

                        <Select
                          label="Role"
                          name="roleName"
                          defaultValue={userEdit.roleName}
                          {...editUser("roleName")}
                          error={editErrors.roleName ? true : false}
                          classes={{
                            root: classes.customSelectField,
                            icon: classes.customSelectIcon,
                          }}
                          disableUnderline
                          onChange={(e) => {
                            setUserEdit({
                              ...userEdit,
                              roleName: e.target.value,
                            });
                          }}
                        >
                          <MenuItem value="">Select option</MenuItem>
                          <MenuItem value="RECRUITER">Recruiter</MenuItem>
                          <MenuItem value="CLIENTCOORDINATOR">
                            {companyType === "COMPANY"
                              ? "Hiring Manager"
                              : "Client Coordinator"}
                          </MenuItem>
                          <MenuItem value="SUBVENDOR">
                            {" "}
                            {companyType === "COMPANY"
                              ? "Freelancer"
                              : "Sub Vendor"}
                          </MenuItem>
                          <MenuItem value="SUBCONTRACT"> {"Vendor"}</MenuItem>
                          {companyType === "COMPANY" ? (
                            <></>
                          ) : (
                            <MenuItem value="FREELANCER"> Freelancer </MenuItem>
                          )}
                        </Select>
                      </FormControl>
                    </Grid>

                    {(userEdit.roleName === "SUBVENDOR" ||
                      userEdit.roleName === "SUBCONTRACT") && (
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        <InputLabel shrink htmlFor="companyName">
                          Company Name
                        </InputLabel>
                        <FormControl className={classes.margin}>
                          <TextField
                            size="small"
                            classes={{ root: classes.customTextField }}
                            InputProps={{ disableUnderline: true }}
                            placeholder="Enter Company Name"
                            id="companyName"
                            defaultValue={userEdit.companyName}
                            {...editUser("companyName")}
                            error={editErrors.companyName ? true : false}
                          />

                          <Typography variant="inherit" color="error">
                            {editErrors.companyName?.message}
                          </Typography>
                        </FormControl>
                      </Grid>
                    )}

                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <InputLabel shrink htmlFor="firstName">
                        First Name
                      </InputLabel>
                      <FormControl className={classes.margin}>
                        <TextField
                          size="small"
                          classes={{ root: classes.customTextField }}
                          InputProps={{ disableUnderline: true }}
                          placeholder="Enter First Name"
                          id="firstName"
                          defaultValue={userEdit.firstName}
                          {...editUser("firstName")}
                          error={editErrors.firstName ? true : false}
                        />

                        <Typography variant="inherit" color="error">
                          {editErrors.firstName?.message}
                        </Typography>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <InputLabel shrink htmlFor="lastName">
                        Last Name
                      </InputLabel>
                      <FormControl className={classes.margin}>
                        <TextField
                          size="small"
                          classes={{ root: classes.customTextField }}
                          InputProps={{ disableUnderline: true }}
                          placeholder="Enter Last Name"
                          id="lastName"
                          defaultValue={userEdit.lastName}
                          {...editUser("lastName")}
                          error={editErrors.lastName ? true : false}
                        />

                        <Typography variant="inherit" color="error">
                          {editErrors.lastName?.message}
                        </Typography>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <InputLabel shrink htmlFor="email">
                        Email
                      </InputLabel>
                      <FormControl className={classes.margin}>
                        <TextField
                          size="small"
                          classes={{ root: classes.customTextField }}
                          InputProps={{ disableUnderline: true }}
                          placeholder="Enter Email"
                          id="email"
                          defaultValue={userEdit.email}
                          {...editUser("email")}
                          error={editErrors.email ? true : false}
                        />

                        <Typography variant="inherit" color="error">
                          {editErrors.email?.message}
                        </Typography>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <InputLabel shrink htmlFor="mobile">
                        Mobile
                      </InputLabel>
                      <FormControl className={classes.margin}>
                        <TextField
                          size="small"
                          classes={{ root: classes.customTextField }}
                          InputProps={{ disableUnderline: true }}
                          type="number"
                          placeholder="Enter Mobile"
                          id="mobile"
                          defaultValue={userEdit.mobile}
                          {...editUser("mobile")}
                          error={editErrors.mobile ? true : false}
                        />

                        <Typography variant="inherit" color="error">
                          {editErrors.mobile?.message}
                        </Typography>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <InputLabel shrink htmlFor="employeeId">
                        Employee ID
                      </InputLabel>
                      <FormControl className={classes.margin}>
                        <TextField
                          size="small"
                          classes={{ root: classes.customTextField }}
                          InputProps={{ disableUnderline: true }}
                          type="number"
                          placeholder="Enter Employee ID"
                          id="employeeId"
                          defaultValue={userEdit.employeeId}
                          {...editUser("employeeId")}
                          error={editErrors.employeeId ? true : false}
                        />

                        <Typography variant="inherit" color="error">
                        {editErrors.employeeId?.message}
                      </Typography>
                     
                      
                      </FormControl>
                    </Grid>
                    {userEdit.roleName === "SUBVENDOR" ||
                    userEdit.roleName === "SUBCONTRACT" ? (
                      <>
                        <Grid item xs={12} sm={6} md={6} lg={6}>
                          <InputLabel shrink htmlFor="companyAddress">
                            Company Address
                          </InputLabel>
                          <FormControl className={classes.margin}>
                            <TextField
                              size="small"
                              classes={{ root: classes.customTextField }}
                              InputProps={{ disableUnderline: true }}
                              placeholder="Enter Company Address"
                              id="companyAddress"
                              defaultValue={userEdit.companyAddress}
                              {...editUser("companyAddress")}
                              error={editErrors.companyAddress ? true : false}
                            />

                            <Typography variant="inherit" color="error">
                              {editErrors.companyAddress?.message}
                            </Typography>
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6} md={6} lg={6}>
                          <InputLabel shrink htmlFor="headOfficeLocation">
                            Head Office Location
                          </InputLabel>
                          <FormControl className={classes.margin}>
                            <TextField
                              size="small"
                              classes={{ root: classes.customTextField }}
                              InputProps={{ disableUnderline: true }}
                              placeholder="Enter Head Office Location"
                              id="headOfficeLocation"
                              defaultValue={userEdit.headOfficeLocation}
                              {...editUser("headOfficeLocation")}
                              error={
                                editErrors.headOfficeLocation ? true : false
                              }
                            />

                            <Typography variant="inherit" color="error">
                              {editErrors.headOfficeLocation?.message}
                            </Typography>
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6} md={6} lg={6}>
                          <InputLabel shrink htmlFor="branchOfficeLocation">
                            Branch Office Location
                          </InputLabel>
                          <FormControl className={classes.margin}>
                            <TextField
                              size="small"
                              classes={{ root: classes.customTextField }}
                              InputProps={{ disableUnderline: true }}
                              placeholder="Enter Branch Office Location"
                              id="branchOfficeLocation"
                              defaultValue={userEdit.branchOfficeLocation}
                              {...editUser("branchOfficeLocation")}
                              error={
                                editErrors.branchOfficeLocation ? true : false
                              }
                            />

                            <Typography variant="inherit" color="error">
                              {editErrors.branchOfficeLocation?.message}
                            </Typography>
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6} md={6} lg={6}>
                          <InputLabel shrink htmlFor="capabilities">
                            Hiring Support
                          </InputLabel>
                          <FormControl className={classes.margin}>
                            <TextField
                              size="small"
                              classes={{ root: classes.customTextField }}
                              InputProps={{ disableUnderline: true }}
                              placeholder="IT/Non-IT/NICHE/SUPER NICHE/Leadership"
                              id="capabilities"
                              defaultValue={userEdit.capabilities}
                              {...editUser("capabilities")}
                              error={editErrors.capabilities ? true : false}
                            />

                            <Typography variant="inherit" color="error">
                              {editErrors.capabilities?.message}
                            </Typography>
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6} md={6} lg={6}>
                          <InputLabel shrink htmlFor="recruiterCapacity">
                            Recruiter Capacity
                          </InputLabel>
                          <FormControl className={classes.margin}>
                            <TextField
                              size="small"
                              classes={{ root: classes.customTextField }}
                              InputProps={{ disableUnderline: true }}
                              placeholder="Enter Recruiter Capacity"
                              id="recruiterCapacity"
                              defaultValue={userEdit.recruiterCapacity}
                              {...editUser("recruiterCapacity")}
                              error={
                                editErrors.recruiterCapacity ? true : false
                              }
                            />

                            <Typography variant="inherit" color="error">
                              {editErrors.recruiterCapacity?.message}
                            </Typography>
                          </FormControl>
                        </Grid>
                      </>
                    ) : (
                      <></>
                    )}
                    {userEdit.roleName === "SUBVENDOR" && (
                      <>
                        <Grid item xs={12} sm={6} md={6} lg={6}>
                          <InputLabel shrink htmlFor="totalExp">
                            Total Experiance as a Recruiter
                          </InputLabel>
                          <FormControl className={classes.margin}>
                            <TextField
                              size="small"
                              classes={{ root: classes.customTextField }}
                              InputProps={{ disableUnderline: true }}
                              placeholder="Enter Total Experiance as a Recruiter"
                              id="totalExp"
                              defaultValue={userEdit.totalExp}
                              {...editUser("totalExp")}
                              error={editErrors.totalExp ? true : false}
                            />
                            <Typography variant="inherit" color="error">
                              {editErrors.totalExp?.message}
                            </Typography>
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6} md={6} lg={6}>
                          <InputLabel shrink htmlFor="currentLocation">
                            Current Location
                          </InputLabel>
                          <FormControl className={classes.margin}>
                            <TextField
                              size="small"
                              classes={{ root: classes.customTextField }}
                              InputProps={{ disableUnderline: true }}
                              placeholder="Enter Current Location"
                              id="currentLocation"
                              defaultValue={userEdit.currentLocation}
                              {...editUser("currentLocation")}
                              error={editErrors.currentLocation ? true : false}
                            />
                            <Typography variant="inherit" color="error">
                              {editErrors.currentLocation?.message}
                            </Typography>
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6} md={6} lg={6}>
                          <InputLabel shrink htmlFor="willingToWork">
                            No of Days willing to work in a Weak
                          </InputLabel>
                          <FormControl className={classes.margin}>
                            <TextField
                              size="small"
                              classes={{ root: classes.customTextField }}
                              InputProps={{ disableUnderline: true }}
                              placeholder="Enter No of Days willing to work in a Weak"
                              id="willingToWork"
                              defaultValue={userEdit.willingToWork}
                              {...editUser("willingToWork")}
                              error={editErrors.willingToWork ? true : false}
                            />
                            <Typography variant="inherit" color="error">
                              {editErrors.willingToWork?.message}
                            </Typography>
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6} md={6} lg={6}>
                          <InputLabel shrink htmlFor="hoursToWork">
                            How many hours do you work in a day
                          </InputLabel>
                          <FormControl className={classes.margin}>
                            <TextField
                              size="small"
                              classes={{ root: classes.customTextField }}
                              InputProps={{ disableUnderline: true }}
                              placeholder="Enter Recruiter Capacity"
                              id="hoursToWork"
                              defaultValue={userEdit.hoursToWork}
                              {...editUser("hoursToWork")}
                              error={editErrors.hoursToWork ? true : false}
                            />
                            <Typography variant="inherit" color="error">
                              {editErrors.hoursToWork?.message}
                            </Typography>
                          </FormControl>
                        </Grid>
                      </>
                    )}
                    {userEdit.roleName === "SUBCONTRACT" && (
                      <>
                        <Grid item xs={12} sm={6} lg={6}>
                          <InputLabel
                            shrink
                            htmlFor="minimumCommercialFee"
                            className="overLengthText"
                          >
                            <span>
                              Mention your Minimum Commercial Fee per Permanent
                              Placement Candidate %
                            </span>
                            <InformationTooltip
                              title={
                                <React.Fragment>
                                  <Typography
                                    color="inherit"
                                    style={{ fontSize: "12px" }}
                                  >
                                    Mention your Minimum Commercial Fee per
                                    Permanent Placement Candidate %
                                  </Typography>
                                </React.Fragment>
                              }
                              placement="bottom"
                              aria-label="title"
                            >
                              <div className={classes.infoTooltipIcon}>
                                <HiQuestionMarkCircle
                                  style={{ color: "#3f3ffe" }}
                                />
                              </div>
                            </InformationTooltip>
                          </InputLabel>
                          <FormControl className={classes.margin}>
                            <Select
                              defaultValue={userEdit.minimumCommercialFee}
                              name="minimumCommercialFee"
                              {...editUser("minimumCommercialFee")}
                              onChange={(e) => {
                                setUserEdit({
                                  ...userEdit,
                                  minimumCommercialFee: e.target.value,
                                });
                              }}
                              error={
                                editErrors.minimumCommercialFee ? true : false
                              }
                              classes={{
                                root: classes.customSelectField,
                                icon: classes.customSelectIcon,
                              }}
                              disableUnderline
                            >
                              <MenuItem value="">Select option</MenuItem>
                              {Array.from(Array(99), (e, i) => {
                                return (
                                  <MenuItem value={i + 1 + "%"}>
                                    {i + 1 + "%"}
                                  </MenuItem>
                                );
                              })}
                            </Select>

                            <Typography variant="inherit" color="error">
                              {editErrors.minimumCommercialFee?.message}
                            </Typography>
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6} lg={6}>
                          <InputLabel shrink htmlFor="contractStaffing">
                            Do you also do Contract Staffing
                          </InputLabel>
                          <Select
                            name="contractStaffing"
                            defaultValue={userEdit.contractStaffing}
                            {...editUser("contractStaffing")}
                            onChange={(e) => {
                              setUserEdit({
                                ...userEdit,
                                contractStaffing: e.target.value,
                              });
                            }}
                            error={editErrors.contractStaffing ? true : false}
                            classes={{
                              root: classes.customSelectField,
                              icon: classes.customSelectIcon,
                            }}
                            disableUnderline
                          >
                            <MenuItem value="">Select option</MenuItem>
                            <MenuItem value="Yes"> Yes </MenuItem>
                            <MenuItem value="No">No </MenuItem>
                          </Select>
                          <Typography variant="inherit" color="error">
                            {editErrors.contractStaffing?.message}
                          </Typography>
                        </Grid>

                        {userEdit.contractStaffing === "Yes" ? (
                          <Grid item xs={12} sm={6} lg={6}>
                            <InputLabel
                              shrink
                              htmlFor="minimumMarkup"
                              className="overLengthText"
                            >
                              <span>
                                Mention your Minimum Commercial Markup % or Flat
                                fee per Contract Candidate (Margin Amount)
                              </span>
                              <InformationTooltip
                                title={
                                  <React.Fragment>
                                    <Typography
                                      color="inherit"
                                      style={{ fontSize: "12px" }}
                                    >
                                      Mention your Minimum Commercial Markup %
                                      or Flat fee per Contract Candidate (Margin
                                      Amount)
                                    </Typography>
                                  </React.Fragment>
                                }
                                placement="bottom"
                                aria-label="title"
                              >
                                <div className={classes.infoTooltipIcon}>
                                  <HiQuestionMarkCircle
                                    style={{ color: "#3f3ffe" }}
                                  />
                                </div>
                              </InformationTooltip>
                            </InputLabel>
                            <FormControl className={classes.margin}>
                              <TextField
                                required={true}
                                classes={{ root: classes.customTextField }}
                                InputProps={{ disableUnderline: true }}
                                size="small"
                                placeholder="Mention your Minimum Commercial Markup % or Flat fee per Contract Candidate (Margin Amount)"
                                id="minimumMarkup"
                                name="minimumMarkup"
                                defaultValue={userEdit.minimumMarkup}
                                {...editUser("minimumMarkup")}
                                error={editErrors.minimumMarkup ? true : false}
                              />
                            </FormControl>
                          </Grid>
                        ) : (
                          ""
                        )}

                        <Grid item xs={12} sm={6} lg={6}>
                          <InputLabel shrink htmlFor="source">
                            From where will you Source Profile
                          </InputLabel>
                          <FormControl className={classes.margin}>
                            <FormGroup row>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={editVendorDetails.JobPortal}
                                    onChange={handleEditSourceProfileCheck}
                                    name="JobPortal"
                                  />
                                }
                                label="Job Portal"
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={editVendorDetails.SocialMedia}
                                    onChange={handleEditSourceProfileCheck}
                                    name="SocialMedia"
                                  />
                                }
                                label="Social Media"
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={editVendorDetails.Reference}
                                    onChange={handleEditSourceProfileCheck}
                                    name="Reference"
                                  />
                                }
                                label="Reference"
                              />
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={editVendorDetails.OthersMention}
                                    onChange={handleEditSourceProfileCheck}
                                    name="OthersMention"
                                  />
                                }
                                label="Others Mention"
                              />
                            </FormGroup>

                            {editVendorDetails.OthersMention === true ? (
                              <TextField
                                required="true"
                                classes={{ root: classes.customTextField }}
                                InputProps={{ disableUnderline: true }}
                                size="small"
                                placeholder="Others Mention"
                                id="OthersMentionValue"
                                name="OthersMentionValue"
                                defaultValue={
                                  editVendorDetails.OthersMentionValue
                                }
                                onChange={(e) => {
                                  handleEditVendorDetailsChange(e);
                                }}
                              />
                            ) : (
                              ""
                            )}

                            <Typography variant="inherit" color="error">
                              {editErrors.sourceProfileFrom?.message}
                            </Typography>
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6} lg={6}>
                          <InputLabel
                            shrink
                            htmlFor="aboutATS"
                            className="overLengthText"
                          >
                            <span>
                              Are you using an ATS (Applicant Tracking System)
                              already? (If Yes)
                            </span>
                            <InformationTooltip
                              title={
                                <React.Fragment>
                                  <Typography
                                    color="inherit"
                                    style={{ fontSize: "12px" }}
                                  >
                                    Are you using an ATS (Applicant Tracking
                                    System) already? (If Yes)
                                  </Typography>
                                </React.Fragment>
                              }
                              placement="bottom"
                              aria-label="title"
                            >
                              <div className={classes.infoTooltipIcon}>
                                <HiQuestionMarkCircle
                                  style={{ color: "#3f3ffe" }}
                                />
                              </div>
                            </InformationTooltip>
                          </InputLabel>
                          <FormControl className={classes.margin}>
                            <TextField
                              classes={{ root: classes.customTextField }}
                              InputProps={{ disableUnderline: true }}
                              size="small"
                              placeholder="Mention ATS Details"
                              id="aboutATS"
                              name="aboutATS"
                              defaultValue={userEdit.aboutATS}
                              {...editUser("aboutATS")}
                              error={editErrors.aboutATS ? true : false}
                            />

                            <Typography variant="inherit" color="error">
                              {editErrors.aboutATS?.message}
                            </Typography>
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6} lg={6}>
                          <InputLabel shrink htmlFor="GSTNumber">
                            Your Company GST Number (Optional)
                          </InputLabel>
                          <FormControl className={classes.margin}>
                            <TextField
                              classes={{ root: classes.customTextField }}
                              InputProps={{ disableUnderline: true }}
                              size="small"
                              placeholder="Enter Your Company GST Number"
                              id="GSTNumber"
                              name="GSTNumber"
                              defaultValue={userEdit.GSTNumber}
                              {...editUser("GSTNumber")}
                              error={editErrors.GSTNumber ? true : false}
                            />

                            <Typography variant="inherit" color="error">
                              {editErrors.GSTNumber?.message}
                            </Typography>
                          </FormControl>
                        </Grid>
                      </>
                    )}
                  </Grid>
                </CardContent>
                <CardActions>
                  <Grid
                    container
                    direction="row"
                    spacing={2}
                    className={classes.clientDrawerFooter}
                  >
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      type="submit"
                      disabled={editIsSubmitting}
                    >
                      Update
                    </Button>
                    <Button
                      variant="contained"
                      size="small"
                      color="secondary"
                      onClick={toggleDrawer(anchor, false)}
                    >
                      Close
                    </Button>
                  </Grid>
                </CardActions>
              </form>
            </Card>
          </List>
        </Box>
      </>
    ) : dataList === "ADD" ? (
      <>
        <AddUser
          toggleDrawer={toggleDrawer}
          handleSubmit={handleSubmit}
          handleAdd={handleAdd}
          setValue={setValue}
          setUserRoleName={setUserRoleName}
          userRoleName={userRoleName}
          roleName={roleName}
          vendorDetails={vendorDetails}
          setVendorDetails={setVendorDetails}
          handleVendorDetailsChange={handleVendorDetailsChange}
          handleSourceProfileCheck={handleSourceProfileCheck}
          errors={errors}
          control={control}
          register={register}
          isContract={isContract}
          isSubmitting={isSubmitting}
        />
      </>
    ) : (
      <>
        <Box sx={{ width: "100%" }} role="presentation">
          <List>
            <Card className={classes.root}>
              <CardHeader>
                <Grid
                  container
                  direction="row"
                  spacing={1}
                  className={classes.drawerViewHeader}
                >
                  <Grid item xs={10} md={6}>
                    <Typography variant="subtitle1">
                      View User - {userEdit.firstName + " " + userEdit.lastName}
                    </Typography>
                  </Grid>

                  <Grid item xs={2} lg={6} className={classes.drawerViewClose}>
                    <CloseIcon
                      className={classes.closeBtn}
                      size="14px"
                      onClick={toggleDrawer(anchor, false)}
                    />
                  </Grid>
                </Grid>
              </CardHeader>

              <CardContent className={classes.drawerViewContent}>
                <Grid container direction="row" spacing={2}>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    {" "}
                    <Typography className={classes.boldtext}>
                      {" "}
                      First Name:{" "}
                    </Typography>{" "}
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    {" "}
                    {userEdit.firstName}{" "}
                  </Grid>

                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    {" "}
                    <Typography className={classes.boldtext}>
                      {" "}
                      Last Name:{" "}
                    </Typography>{" "}
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    {" "}
                    {userEdit.lastName}{" "}
                  </Grid>

                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    {" "}
                    <Typography className={classes.boldtext}>
                      {" "}
                      User Category:{" "}
                    </Typography>{" "}
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    {userEdit.roleName === "RECRUITER"
                      ? "Recruiter"
                      : userEdit.roleName === "CLIENTCOORDINATOR"
                      ? "Hiring Manager"
                      : userEdit.roleName === "SUBVENDOR"
                      ? companyType === "COMPANY"
                        ? "Freelancer"
                        : "Sub Vendor"
                      : userEdit.roleName === "SUBCONTRACT"
                      ? "Vendor"
                      : userEdit.roleName === "FREELANCER"
                      ? "Freelancer"
                      : ""}
                  </Grid>

                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    {" "}
                    <Typography className={classes.boldtext}>
                      Email:
                    </Typography>{" "}
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    {" "}
                    {userEdit.email}{" "}
                  </Grid>

                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    {" "}
                    <Typography className={classes.boldtext}>
                      {" "}
                      Mobile:{" "}
                    </Typography>{" "}
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    {" "}
                    {userEdit.mobile}{" "}
                  </Grid>

                  {userEdit.roleName === "SUBVENDOR" ? (
                    <>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        {" "}
                        <Typography className={classes.boldtext}>
                          {" "}
                          Company Name:{" "}
                        </Typography>{" "}
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        {" "}
                        {userEdit.companyName}{" "}
                      </Grid>
                    </>
                  ) : (
                    ""
                  )}

                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    <Typography className={classes.boldtext}>
                      {" "}
                      Employee Id:{" "}
                    </Typography>{" "}
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                  {userEdit.employeeId ?
                        <span>{userEdit.employeeId}{" "}</span> :
                      <Typography component="span" className="emp-details-unvailable" color="error">
                          Unavailable
                      </Typography>
                      }
                  </Grid>

                  {(userEdit.roleName === "SUBVENDOR" ||
                    userEdit.roleName === "SUBCONTRACT") && (
                    <>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        {" "}
                        <Typography className={classes.boldtext}>
                          {" "}
                          Company Address:{" "}
                        </Typography>{" "}
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        {" "}
                        {userEdit.companyAddress}{" "}
                      </Grid>

                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        {" "}
                        <Typography className={classes.boldtext}>
                          {" "}
                          Head office Location:{" "}
                        </Typography>{" "}
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        {" "}
                        {userEdit.headOfficeLocation}{" "}
                      </Grid>

                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        {" "}
                        <Typography className={classes.boldtext}>
                          {" "}
                          Branch office Location:{" "}
                        </Typography>{" "}
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        {" "}
                        {userEdit.branchOfficeLocation}{" "}
                      </Grid>

                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        {" "}
                        <Typography className={classes.boldtext}>
                          {" "}
                          Hiring Support:{" "}
                        </Typography>{" "}
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        {" "}
                        {userEdit.capabilities}{" "}
                      </Grid>

                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        {" "}
                        <Typography className={classes.boldtext}>
                          {" "}
                          Recruiter Capacity:{" "}
                        </Typography>{" "}
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        {" "}
                        {userEdit.recruiterCapacity}{" "}
                      </Grid>
                    </>
                  )}

                  {userEdit.roleName === "SUBVENDOR" && (
                    <>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        {" "}
                        <Typography className={classes.boldtext}>
                          {" "}
                          Total Experiance as a Recruiter:{" "}
                        </Typography>{" "}
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        {" "}
                        {userEdit.totalExp}{" "}
                      </Grid>

                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        {" "}
                        <Typography className={classes.boldtext}>
                          {" "}
                          Current Location:{" "}
                        </Typography>{" "}
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        {" "}
                        {userEdit.currentLocation}{" "}
                      </Grid>

                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        {" "}
                        <Typography className={classes.boldtext}>
                          {" "}
                          No of Days willing to work in a Weak:{" "}
                        </Typography>{" "}
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        {" "}
                        {userEdit.willingToWork}{" "}
                      </Grid>

                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        {" "}
                        <Typography className={classes.boldtext}>
                          {" "}
                          How many hours do you work in a day:{" "}
                        </Typography>{" "}
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        {" "}
                        {userEdit.hoursToWork}{" "}
                      </Grid>
                    </>
                  )}

                  {userEdit.roleName === "SUBCONTRACT" && (
                    <>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        {" "}
                        <Typography className={classes.boldtext}>
                          {" "}
                          Minimum Commercial Fee per Permanent Placement
                          Candidate %:{" "}
                        </Typography>{" "}
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        {" "}
                        {userEdit.minimumCommercialFee}{" "}
                      </Grid>

                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        {" "}
                        <Typography className={classes.boldtext}>
                          {" "}
                          Contract Staffing:{" "}
                        </Typography>{" "}
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        {" "}
                        {userEdit.contractStaffing}{" "}
                      </Grid>

                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        {" "}
                        <Typography className={classes.boldtext}>
                          {" "}
                          Minimum Commercial Markup % or Flat fee per Contract
                          Candidate :{" "}
                        </Typography>{" "}
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        {" "}
                        {userEdit.minimumMarkup}{" "}
                      </Grid>

                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        {" "}
                        <Typography className={classes.boldtext}>
                          {" "}
                          Source Profile:{" "}
                        </Typography>{" "}
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        {" "}
                        {userEdit.sourceProfileFrom}{" "}
                      </Grid>

                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        {" "}
                        <Typography className={classes.boldtext}>
                          {" "}
                          Are you using an ATS:{" "}
                        </Typography>{" "}
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        {" "}
                        {userEdit.aboutATS}{" "}
                      </Grid>

                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        {" "}
                        <Typography className={classes.boldtext}>
                          {" "}
                          Company GST Number:{" "}
                        </Typography>{" "}
                      </Grid>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        {" "}
                        {userEdit.GSTNumber}{" "}
                      </Grid>
                    </>
                  )}

                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    {" "}
                    <Typography className={classes.boldtext}>
                      {" "}
                      Posted Date:{" "}
                    </Typography>{" "}
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6}>
                    {" "}
                    {moment(userEdit.createdAt).format("DD-MM-YYYY")}{" "}
                  </Grid>
                </Grid>
              </CardContent>
              <CardActions>
                <Grid
                  container
                  direction="row"
                  spacing={2}
                  className={classes.clientDrawerFooter}
                >
                  <Button
                    variant="contained"
                    size="small"
                    color="secondary"
                    onClick={toggleDrawer(anchor, false)}
                  >
                    Close
                  </Button>
                </Grid>
              </CardActions>
            </Card>
          </List>
        </Box>
      </>
    );

  const table_options = {
    textLabels: {
      body: {
        noMatch: "Oops! Matching record could not be found",
      },
    },
    sort: false,
    selectableRows: "none",
    search: false,
    filter: false,
    print: false,
    download: false,
    pagination: false,
    customToolbar: () => <HeaderElements />,
    page: page,
    responsive: mobileQuery === true ? "vertical" : "standard",
  };

  const table_column = [
    {
      name: "S.No",
    },
    {
      name: "Actions",
    },
    {
      name: "Name",
    },
    {
      name: "Email",
    },
    {
      name: "Employee ID",
    },

    {
      name: "Mobile",
    },

    {
      name: "User Category",
    },

    {
      name: "Status",
    },
    {
      name: "Posted Date",
    },
  ];

  return (
    <>
      <Grid container direction="row" spacing={2}>
        <Grid item xs={6}>
          <PageTitle title="Users" />
        </Grid>

        <Grid item xs={6} className={classes.drawerClose}>
          <div className={classes.lgButton}>
            
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={(e) => {
                reset();
                editreset();
                setDataList("ADD");
                setState({ ...state, right: true });
              }}
              className={classes.addUser}
              startIcon={<AddCircleIcon />}
            >
              Add Other User
            </Button>
          </div>
          <div className={classes.smButton}>
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={(e) => {
                reset();
                editreset();
                setDataList("ADD");
                setState({ ...state, right: true });
              }}
              className={classes.addUser}
              startIcon={<AddCircleIcon />}
            >
              Add
            </Button>
          </div>
          <SwipeableDrawer
            anchor="right"
            open={state["right"]}
            onClose={toggleDrawer("right", false)}
            onOpen={toggleDrawer("right", true)}
            classes={{ paper: classes.clientDrawer }}
          >
            {list("right")}
          </SwipeableDrawer>
        </Grid>
      </Grid>

      <form
        ref={filterRef}
        onSubmit={(e) => {
          e.preventDefault();
          getFilterData();
        }}
      >
        <Grid container spacing={2} className={classes.filterGap}>
          <div className={classes.filterFullWidth}>
            <InputLabel shrink id="roleName">
              {" "}
              User Category{" "}
            </InputLabel>

            <TextField
              name="roleName"
              variant="standard"
              defaultValue=""
              onChange={(e) => setRoleName(e.target.value)}
              value={roleName}
              InputProps={{ className: classes.h34 }}
              disableunderline="true"
              select
            >
              <MenuItem value="SUBVENDOR">
                {" "}
                {companyType === "COMPANY" ? "Freelancer" : "Sub Vendor"}{" "}
              </MenuItem>
              <MenuItem value="SUBCONTRACT"> {"Vendor"} </MenuItem>
              {companyType === "COMPANY" ? (
                <></>
              ) : (
                <MenuItem value="FREELANCER"> Freelancer </MenuItem>
              )}
            </TextField>
          </div>
          <Autocomplete
            className={classes.filterFullWidth}
            options={userName}
            getOptionLabel={(option) => {
              const roleName = option.user?.role?.roleName;
              const firstName = option.firstName;
              const lastName = option.lastName;
              let label = `${firstName} ${lastName}`;
              if (roleName) {
                label += ` (${roleName})`;

                if (roleName === "SUBVENDOR") {
                  label = label.replace(
                    "(SUBVENDOR)",
                    `(${option?.companyName})`,
                  );
                } else if (roleName === "CLIENTCOORDINATOR") {
                  label = label.replace(
                    "(CLIENTCOORDINATOR)",
                    "(Hiring Manager)",
                  );
                }
              }

              return label;
            }}
            onChange={(event, value) => setRecruiterId(value)}
            value={recruiterId}
            size="small"
            renderInput={(params) => (
              <TextField
                {...params}
                name="recruiterId"
                variant="standard"
                label={companyType === "COMPANY" ? "User" : "Recruiter"}
                InputLabelProps={{ shrink: true }}
                type="text"
              />
            )}
          />

          <TextField
            name="fromDate"
            label="From"
            size="small"
            type="date"
            variant="standard"
            format={"DD/MM/YYYY"}
            InputLabelProps={{ shrink: true }}
            className={classes.filterWidth}
            defaultValue={fromDate}
            onChange={handleFromDateChange}
          />

          <TextField
            name="toDate"
            label="To"
            size="small"
            type="date"
            format={"DD/MM/YYYY"}
            variant="standard"
            InputLabelProps={{ shrink: true }}
            className={classes.filterWidth}
            defaultValue={toDate}
            onChange={handleToDateChange}
          />

          <div className={classes.buttons}>
            <Button
              variant="contained"
              size="small"
              type="submit"
              color="primary"
            >
              Search
            </Button>
            <Button
              variant="contained"
              size="small"
              color="secondary"
              onClick={() => resetForm()}
            >
              Reset
            </Button>
          </div>
        </Grid>
      </form>

      <Grid container spacing={2}>
        <Grid item xs>
          <MUIDataTable
            options={table_options}
            columns={table_column}
            data={userData.map((item, index) => {
              return [
                currerntPage !== 0
                  ? 10 * currerntPage - 10 + index + 1
                  : index + 1,

                <Grid container className={classes.space}>
                  <Grid item xs className={classes.toolAlign}>
                    <UserActions
                      index={index}
                      item={item}
                      activeIndex={activeIndex}
                      handleMenuClick={handleMenuClick}
                      anchorEl={anchorEl}
                      state={state}
                      setState={setState}
                      setDataList={setDataList}
                      userEdit={userEdit}
                      editVendorDetails={editVendorDetails}
                      setEditVendorDetails={setEditVendorDetails}
                      editreset={editreset}
                      setUserEdit={setUserEdit}
                      setRecruiterId={setRecruiterId}
                      handleNDAOpen={handleNDAOpen}
                    />
                  </Grid>
                </Grid>,
                <>
                  {item.firstName + " " + item.lastName}
                  {item.companyName && ` (${item.companyName})`}
                </>,
                item.user.email,
                item.employeeId ? item.employeeId  :
                <Typography component="span" className="emp-details-unvailable" color="error">
                    Unavailable
                </Typography>
                 ,
                item.mobile,
                item.user?.roleName === "RECRUITER"
                  ? "Recruiter"
                  : item.user?.roleName === "CLIENTCOORDINATOR"
                  ? "Hiring Manager"
                  : item.user?.roleName === "SUBCONTRACT"
                  ? "Vendor"
                  : item.user?.roleName === "SUBVENDOR"
                  ? companyType === "COMPANY"
                    ? "Freelancer"
                    : "Sub Vendor"
                  : item.user?.roleName === "FREELANCER"
                  ? "Freelancer"
                  : "",
                <Switch
                  checked={item.user.isActive}
                  onChange={(e) => {
                    handleStatus(item.user.id, e.target.checked);
                  }}
                  color="primary"
                  inputProps={{ "aria-label": "primary checkbox" }}
                />,
                moment(item.createdAt).format("DD-MM-YYYY"),
              ];
            })}
          />

          <Dialog
            aria-labelledby="dialog-title"
            onClose={handleNDAClose}
            open={ndaFileOpen}
            fullWidth={true}
            maxWidth="md"
            PaperProps={{
              style: {
                width: "100%",
              },
            }}
          >
            <DialogContent>
              <Grid container direction="row" spacing={2}>
                <div
                  className={`${classes.heading} ${classes.inputRoot} ${classes.pdfModalTitleText}`}
                >
                  <div
                    className={classes.inputRoot}
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <Typography variant="subtitle2">
                      {" "}
                      Non-Disclosure Agreement{" "}
                    </Typography>
                    <Typography
                      variant="subtitle2"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "15px",
                      }}
                    >
                      {decode.role === "ADMIN" && ndaFile && (
                        <>
                          <a
                            style={{ fontSize: "1.3rem", color: "#29b229" }}
                            href={ndaFile}
                          >
                            {" "}
                            <IoMdDownload />{" "}
                          </a>
                          <div
                            style={{
                              fontSize: "1.3rem",
                              color: "#D71313",
                              cursor: "pointer",
                            }}
                            onClick={handleDeleteOpen}
                          >
                            {" "}
                            <AiOutlineDelete />{" "}
                          </div>
                        </>
                      )}
                    </Typography>
                  </div>

                  <div className={classes.pdfModalCloseBtn}>
                    <CloseIcon
                      className={classes.closeBtn}
                      onClick={handleNDAClose}
                    />
                  </div>
                </div>
                {ndaFile ? (
                  <Grid item xs={12}>
                    {fileExtension === "pdf" ? (
                      <CustomPdfView resumeUrl={ndaFile} />
                    ) : (
                      <div
                        className={classes.iframediv}
                        style={{ marginTop: "40px" }}
                      >
                        <iframe
                          src={
                            "https://docs.google.com/a/umd.edu/viewer?url=" +
                            ndaFile +
                            "&embedded=true"
                          }
                          title="File"
                          width="100%"
                          height="500"
                          sandbox="allow-scripts allow-same-origin"
                        ></iframe>
                        <div className={classes.iframeLogo}></div>
                      </div>
                    )}
                  </Grid>
                ) : (
                  <Grid
                    item
                    xs={12}
                    style={{ marginTop: "40px", padding: "20px" }}
                  >
                    <Typography
                      variant="body"
                      style={{ color: "#686D76", textAlign: "center" }}
                      className={classes.flexCenter}
                    >
                      {" "}
                      No file found here...
                    </Typography>
                  </Grid>
                )}
                <div className={classes.sendWhatsapp + " " + classes.inputRoot}>
                  <Button
                    variant="contained"
                    size="small"
                    color="secondary"
                    onClick={handleNDAClose}
                  >
                    Close
                  </Button>
                </div>
              </Grid>
            </DialogContent>
          </Dialog>

          <Dialog
            onClose={handleDeleteClose}
            aria-labelledby="dialog-title"
            open={deleteOpen}
            width="md"
            PaperProps={{
              style: {
                width: "100%",
              },
            }}
          >
            <DialogTitle className={classes.digTitle}>
              <div className={classes.center}>
                <Typography
                  variant="subtitle2"
                  className={classes.digColor + " " + classes.digCenter}
                >
                  Confirmation
                </Typography>
                <div className={classes.drawerClose}>
                  <CloseIcon
                    className={classes.digClose}
                    size="14px"
                    onClick={handleDeleteClose}
                  />
                </div>
              </div>
            </DialogTitle>
            <DialogContent>
              <Typography variant="subtitle2" className={classes.center}>
                Are you sure want to delete the Non-Disclosure Agreement data
              </Typography>

              <Grid className={classes.sendWhatsapp}>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={handleDeleteNDAFile}
                >
                  Confirm
                </Button>

                <Button
                  variant="contained"
                  size="small"
                  color="secondary"
                  onClick={handleDeleteClose}
                >
                  Close
                </Button>
              </Grid>
            </DialogContent>
          </Dialog>

          <Grid container spacing={2} className={classes.pagination}>
            <TablePagination
              rowsPerPageOptions={[50]}
              component="div"
              count={count}
              rowsPerPage={10}
              page={page}
              onPageChange={handleChangePage}
            />
          </Grid>
        </Grid>
      </Grid>

      

      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
}
